<template>
  <v-img
    src="/static/_v1/pd/pictures/analyzes/molecule.png"
    class="discount-banner-image"
    :class="isMobile ? 'discount-banner-image-mobile' : 'discount-banner-image-desktop'"
    :min-width="size"
    :min-height="size"
    :max-height="size"
    :max-width="size"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

const isMobile = window.MOBILE_VERSION

const size = computed(() => (isMobile ? '125px' : '150px'))
</script>

<style lang="scss">
.discount-banner-image {
  position: relative;
  transform: rotate(180deg);

  &-mobile {
    bottom: 43px;
    left: 40px;
  }

  &-desktop {
    bottom: 15px;
    left: 0;
  }
}
</style>
